import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import { clearAutomobileVehicleState, fetchAutomobileIntrestedPartieListAsync } from "../../../../../../redux/automobileVehicle/automobileVehicleActions";

export const useAutomobileVehicleInterested = (customerPolicyId?: number) => {
  const dispatch = useDispatchWrapper();
   const { interestedPartyList, interestedPartyListLoading } = useSelector(
	  (storeState: IStoreState) => storeState.automobile.vehicle.interestedParty
	);

  const interestedDropdown = React.useMemo(() => {
	return interestedPartyList.map((item) => {
	  return {
		label: `${item.number || "--"} (Code: ${
		  item.interested_party_code || "N/A"
		} )`,
		value: item.number || "",
	  };
	});
  }, [interestedPartyList]);

  const refreshData = () => {
	if (customerPolicyId) {
		dispatch(fetchAutomobileIntrestedPartieListAsync(Number(customerPolicyId), "ACTIVE"));
	  }

  }

  React.useEffect(() => {
	if (customerPolicyId) {
	  dispatch(fetchAutomobileIntrestedPartieListAsync(Number(customerPolicyId), "ACTIVE"));
	}
	return () => {
	  dispatch(clearAutomobileVehicleState());
	};
  }, [customerPolicyId]);

  return { interestedDropdown, interestedPartyList,refreshData};
};
